import { CesfNotification } from "@/services/cesf/models";
import { ApiPagedResult, BaseService } from "@k-digitale/kappa";

class MultichannelNotificationService extends BaseService {

    async setNotificationSeen(id: number) : Promise<boolean> {
        const response = await this.tryExecute(
            this.api.post(`multichannelNotification/${id}/set-seen`)
        );

        return response!.data;
    }

    //TODO Spostare su api platform
    async getUserUnseenNotifications(pageIndex: number, pageSize: number): Promise<ApiPagedResult<CesfNotification>> {
        const response = await this.tryExecute(
            this.api.get<any>(`cesf/notifications/user-unseen-notifications`, { params: {pageIndex, pageSize} })
        );

        return response!.data;
    }
}

export const multichannelNotificationService = new MultichannelNotificationService();